import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import Circle from '../../models/Circle.js';
import { toast } from 'react-toastify';
import FormPartial from './FormPartial.js';

const Edit = (props) => {
  const [circle, setCircle] = useState((new Circle()).toStateJson());
  let circleObj = new Circle(circle);
  const [fetchApi] = getApi('showBranch');
  const [updateApi] = getApi('updateBranch');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setCircle((new Circle(response.data.branch)).toStateJson());
    } catch(error) {
      toast.error(error?.data?.message || "Something Went Wrong !");
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/circles");
      toast.success("Updated Successfully");
    } catch(error) {
      circleObj.set_api_errors(error?.data?.data?.errors);
      toast.error(error?.data?.message  || 'Something went wrong !');
    }
  }

  const onUpdateClick = () => {
    try{
      updateRecord((new Circle(circle)).toApiJson());
    } catch(error){
      setCircle(new Circle(circle));
    }
  }

  const onBackClick = () => {
    navigate("/circles");
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditCirclePage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Circle", url: '/circles' }, { label: "Edit" }]}
    className={'circle-edit-page'}
  >
    <PageContentWrapper contentHeading={"Edit Circle"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial circle={circle} setCircle={setCircle}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>
                Back
              </button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>
                Update Circle
              </button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
